export function replaceSpacesWithUnderscore(inputString: string): string {
    return inputString.includes(' ') ? inputString.replace(/ /g, '_') : inputString;
}

export const FEATURE_FLAGS: any = {
    // Add all the feature flags here
    IMAGE_UPLOAD: true,    // before making it true, make sure to add image(text) coulmn in style table in db
    OS_BOX_FLAG: false, // os box flag, before making it true, make sure to add osCaseQty(jsonb) column in style table in db
}

export async function getImageBase64(imagePath: string) {
    // Check if the incoming imagePath is already in base64 format
    if (imagePath.startsWith('data:image/')) {
        // If it's already base64, just return it
        return imagePath;
    }
    // Otherwise, treat imagePath as a URL and fetch it to convert to base64
    try {
        const response = await fetch(imagePath); // Fetch the image as a Blob
        const blob = await response.blob();

        // Convert Blob to base64 string
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                resolve(reader.result as string);  // Return the base64 string
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(blob);  // Read the blob as a base64 string
        });
    } catch (error) {
        console.error('Error fetching image:', error);
        return '';
    }
}

export const locationData = [{
    company: 'DCCAL',
    location: 'DC-Caledonia',
    name: 'SVP SPORTS DCCAL',
    address: '1100 Caledonia Rd,',
    city: 'North York, ON M6A 2W5',
    email: 'gash@svpsports.ca',
    corporate_no: '2023855 Ontario Inc.',
    contact: [
        { name: 'Gash', phone: '647-894-9856', email: 'gash@svpsports.ca' },
        { name: 'Bhavin', phone: '437-437-1309', email: '' },
    ],
    note: 'BACK AT DOCK NOTE: 4 ONLY CONTACT: GASH(647-894-9856) OR BHAVIN(437-437-1309)'
},
{
    company: 'DC',
    location: 'DC',
    name: 'SVP SPORTS DC',
    address: '400 Harry Walker Pkwy S,',
    city: 'Newmarket, ON L3Y 9C4',
    email: 'justin@svpsports.ca',
    corporate_no: '2138398 Ontario Inc.',
    contact: [
        { name: 'Justin', phone: '647-894-9856', email: 'justin@svpsports.ca' },
        { name: 'Charles', phone: '647-885-3108', email: 'charles@svpsports.ca' },
    ],
    note: ''
},
{
    company: 'OAUR',
    location: 'AURORA',
    name: 'SVP SPORTS OPM-AUR',
    address: '100 Vandorf Sideroad,',
    city: 'Aurora, ON L4G 3G9',
    email: 'justin@svpsports.ca',
    corporate_no: '1000942784 Ontario Inc.',
    contact: [
        { name: 'Glen', phone: '', email: '' },
    ]
},
{
    company: 'SVPQW',
    location: 'QUEENSWAY',
    name: 'SVP SPORTS SVP-QW',
    address: '1255 The Queensway',
    city: 'Etobicoke ON M8Z 1S2',
    email: 'justin@svpsports.ca',
    corporate_no: ' Ontario Inc.',
    contact: [
        { name: 'Gle', phone: '', email: '' },
    ],
    note: 'DO NOT BACK AT DOCK NO 3 CALL JASON 905-208-7641 OR ERIC 647-209-8947'
},
{
    company: 'SVPKG',
    location: 'KINGSTON',
    name: 'SVP SPORTS SVP-KINGSTON',
    address: '636 Gardiners Rd., Unit #12,',
    city: 'Kingston, ON, K7M 3X9',
    email: 'justin@svpsports.ca',
    corporate_no: '1000829497 Ontario Inc.',
    contact: [
        { name: 'Ryan', phone: '647-355-4300', email: 'ryan@svpsports.ca' },
    ]
}
]

export function getLocationInfo(location?: string, company?: string, name?: string, address?: string, city?: string, phone?: string, email?: string, corporate_no?: string, contact?: any, note?: string) {
    // based on incoming values, return the corresponding location information
    if (location) {
        return locationData.find((loc) => loc.location === location);
    }
    if (company) {
        return locationData.find((location) => location.company === company);
    }
    if (name) {
        return locationData.find((location) => location.name === name);
    }
    return null;
}
export function getShippingDetails(location: string) {
    switch (location) {
        case 'DC-Caledonia':
            return {
                company: 'DCCAL',
                name: 'SVP SPORTS DCCAL',
                address: '1100 Caledonia Rd,',
                city: 'North York, ON M6A 2W5',
                email: 'gash@svpsports.ca',
                corporate_no: '2023855 Ontario Inc.',
                contact: [
                    { name: 'Gash', phone: '647-894-9856', email: 'gash@svpsports.ca' },
                    { name: 'Bhavin', phone: '437-437-1309', email: '' },
                ],
                note: 'BACK AT DOCK NOTE: 4 ONLY CONTACT: GASH(647-894-9856) OR BHAVIN(437-437-1309)'
            }
        case 'DC':
            return {
                company: 'DC',
                name: 'SVP SPORTS DC',
                address: '400 Harry Walker Pkwy S,',
                city: 'Newmarket, ON L3Y 9C4',
                email: 'justin@svpsports.ca',
                corporate_no: '2138398 Ontario Inc.',
                contact: [
                    { name: 'Justin', phone: '647-894-9856', email: 'justin@svpsports.ca' },
                    { name: 'Charles', phone: '647-885-3108', email: 'charles@svpsports.ca' },
                ],
                note: ''
            }
        case 'OPM-Aurora':
            return {
                company: 'OAUR',
                name: 'SVP SPORTS OPM-AUR',
                address: '100 Vandorf Sideroad,',
                city: 'Aurora, ON L4G 3G9',
                email: 'justin@svpsports.ca',
                corporate_no: '1000942784 Ontario Inc.',
                contact: [
                    { name: 'Glen', phone: '', email: '' },
                ]
            }
        case 'SVP-Queensway':
            return {
                company: 'SVPQW',
                name: 'SVP SPORTS SVP-QW',
                address: '1255 The Queensway',
                city: 'Etobicoke ON M8Z 1S2',
                email: 'justin@svpsports.ca',
                corporate_no: ' Ontario Inc.',
                contact: [
                    { name: 'Gle', phone: '', email: '' },
                ],
                note: 'DO NOT BACK AT DOCK NO 3 CALL JASON 905-208-7641 OR ERIC 647-209-8947'
            }
        case 'SVP-Kingston':
            return {
                company: 'SVPKG',
                name: 'SVP SPORTS SVP-KINGSTON',
                address: '636 Gardiners Rd., Unit #12,',
                city: 'Kingston, ON, K7M 3X9',
                email: 'justin@svpsports.ca',
                corporate_no: '1000829497 Ontario Inc.',
                contact: [
                    { name: 'Ryan', phone: '647-355-4300', email: 'ryan@svpsports.ca' },
                ]
            }
        default:
            return {
                company: 'DC-Caledonia',
                name: 'SVP SPORTS DC-CAL',
                address: '1100 Caledonia Rd, ON M6A 2W5 ',
                city: 'Toronto, ON M6A 2W5',
                email: 'gash@svpsports.ca',
                corporate_no: '2138398 Ontario Inc.',
            }
    }
}

export function capitalizeFirstLetter(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
}

export function capetalizeStatus(status: string) {
    // Capitalize the first letter and remove the _ and put space
    return status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ');
}

export const DisplayStatus: Record<string, string> = {
    restock: 'Pending',
    picked: 'Picked',
    not_found: 'Not Found',
    picked_all: 'Picked All',
    allocation: 'Allocation'
}

export function formatDate(dateString: string): string {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    };
    return date.toLocaleDateString('en-US', options);
}
// export const IMAGE_PATH = `http://192.168.0.135:3000/public/styleImages/`;